import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliField from '@blibli/blue.field/dist/field/blue/Field'
import BliTextField from '@blibli/blue.text-field/dist/text-field/blue/TextField'
import CONSTANTS from '@/constants'
import { mapActions, mapState } from "pinia"
import { useApplicationStore } from '@/store/application'
import { useJobTrackingStore } from '@/store/job-tracking'
import { app } from '@/config'

const FIELDS = ['email', 'code']

export default {
    components: {
        BliButton,
        BliField,
        BliTextField
    },
    computed: {
        ...mapState(useApplicationStore, ['applicationStatus', 'applicationStatusError']),
    },
    data() {
        return {
            trackingForm: {
                email: '',
                code: ''
            },
            errors: [],
            requiredField: 'Required field'
        }
    },
    methods: {
        ...mapActions(useApplicationStore, ['getApplicationStatus']),
        ...mapActions(useJobTrackingStore, ['getJobTracking']),
        async track() {
            if (!this.validateForm()) return
            // this.getApplicationStatus({
            //     data: {
            //         email: this.trackingForm.email,
            //         code: this.trackingForm.code
            //     },
            //     success: (response) => {
            //         if (response.body.status.code === 1000){
            //             this.$router.push({ name: 'TrackResult', params: { email: this.trackingForm.email, code: this.trackingForm.code } })
            //         }
            //         this.trackingForm.email = ''
            //         this.trackingForm.code = ''
            //     }
            // })
            this.$router.push({
                name: app.routerName.jobTrackingResult,
                query: {
                    email: this.trackingForm.email,
                    applicationId: this.trackingForm.code
                }
            })
        },
        validateForm() {
            const errors = {}
            FIELDS.forEach(field => {
                if (field === 'email' && this.trackingForm.email && !CONSTANTS.REGEX.EMAIL.test(this.trackingForm[field])) {
                    errors[field] = '* Invalid email'
                }
                else if(field === 'code' && !CONSTANTS.REGEX.SPECIAL_CHARACTERS.test(this.trackingForm[field])){
                    errors[field] = '* Invalid Application id'
                }
                else {
                    if (this.trackingForm[field].trim()) return
                    errors[field] = this.requiredField
                }
            })
            this.errors = errors
            return Object.keys(errors).length === 0
        },
    },
    // watch: {
    //     'applicationStatusError'() {
    //         this.trackingForm.email = ''
    //         this.trackingForm.code = ''
    //         this.errorNotification.show = true
    //         this.errorNotification.msg = this.applicationStatusError.desc
    //     }
    // }
}
